import {
  PhoneNumberProvider,
  PhoneNumberUseCase,
  ProviderTransitionSchema,
  TextMessagingVerificationStatus,
} from "@redotech/redo-model/phone/phone-number";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

const PhoneNumberAdminRowSchema = z.object({
  _id: zExt.objectId(),
  number: z.string(),
  numberType: z.enum(["toll-free", "10dlc"]),
  teamId: z.string(),
  teamName: z.string(),
  provider: createEnum(PhoneNumberProvider).optional(),
  useCase: createEnum(PhoneNumberUseCase).optional(),
  verificationStatus: createEnum(TextMessagingVerificationStatus).optional(),
  liveVerificationStatus: z
    .enum([
      "pending",
      "verified",
      "unverified",
      "rejected",
      "not_found",
      "unknown",
    ])
    .optional(),
  liveVerificationMessage: z.string().optional(),
  lastError: z.string().nullish(),
  tollFreeVerificationId: z.string().nullish(),
  tenDlcCampaignRegistrationId: z.string().nullish(),
  providerTransition: ProviderTransitionSchema.nullish(),
});

export type PhoneNumberAdminRow = z.infer<typeof PhoneNumberAdminRowSchema>;

export const getAllPhoneNumbers = {
  name: "getAllPhoneNumbers" as const,
  input: z.object({
    page: z.number().min(1).default(1),
    pageSize: z.number().min(1).max(50).default(20),
    searchTerm: z.string().optional(),
    verificationStatus: z
      .array(createEnum(TextMessagingVerificationStatus))
      .optional(),
    provider: z.array(createEnum(PhoneNumberProvider)).optional(),
    useCase: z.array(createEnum(PhoneNumberUseCase)).optional(),
    numberType: z.array(z.enum(["toll-free", "10dlc"])).optional(),
  }),
  output: z.object({
    phoneNumbers: z.array(PhoneNumberAdminRowSchema),
    totalCount: z.number(),
  }),
};
